const REPORT_OF_TYPE = {
  BATCH: 'BATCH',
  DATE: 'DATE',
}

export {
  REPORT_OF_TYPE,
}
